module.exports = __webpack_public_path__ + "images/ds-tyf-bg-billing.webp";